import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/petsShopLab/banner.png'
import navColor from '../../assets/petsShopLab/nav/color.png'
import navBg from '../../assets/petsShopLab/nav/nav_bg.png'

import calcRemFn from '../calcRem'

const prodId1 = '96792'
const prodId2 = '96793'
const prodId3 = '96795'
const prodId4 = '96796'
const prodId5 = '96797'
const prodId6 = '96799'
const prodId7 = '96800'
// 96792 萌宠头像照
// 96793 多彩洞洞照
// 96795 萌宠职业照
// 96796 萌宠登记照
// 96797 人宠同款照
// 96799 宠物肖像照
// 96800 人宠封面照

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(99),
    backgroundImage: `url(${navColor})`,
    marginTop: calcRemFn(-1),
  },
  navCtn: {
    height: calcRemFn(99),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(12)} ${calcRemFn(42)} 0`
  },
  topBtnBaseCss: {
    width: calcRemFn(94),
    height: calcRemFn(25.5),
  },
  bottomBtnLayout: {
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: `${calcRemFn(3)} ${calcRemFn(40)} 0`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(94),
    height: calcRemFn(25.5),
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
    },
    {
      key: 'top2',
      show: true,
    },
    {
      key: 'top3',
      show: true,
    }
  ],
  bottom: {
    top1: [],
    top2: [],
    top3: []
  },
}

navData.top = navData.top.map((item, index) => {
  item.img = require(`../../assets/petsShopLab/nav/far${index + 1}.png`)
  item.img_actived = require(`../../assets/petsShopLab/nav/far${index + 1}_active.png`)
  return item
})

const sonTmp1 = [[1, 2, 3, 4, 5], [6, 7, 8], [9]]
sonTmp1.forEach((item, index) => {
  let flag = index + 1
  item.forEach((ele, idx) => {
    navData.bottom['top' + flag].push({
      key: '_i' + (idx + 1),
      show: true,
      img: require(`../../assets/petsShopLab/nav/son${ele}.png`),
      img_actived: require(`../../assets/petsShopLab/nav/son${ele}_active.png`),
    })
  })
})

const pictures = [
  {
    id: prodId1,
    type: 'blue',
    ref: `top1_i1`,
    farName: `top1`,
    sonName: `_i1`,
    son: [
      require(`../../assets/petsShopLab/ctn/2.png`)
    ]
  },
  {
    id: prodId2,
    type: 'blue',
    ref: `top1_i2`,
    farName: `top1`,
    sonName: `_i2`,
    son: [
      require(`../../assets/petsShopLab/ctn/3.png`)
    ]
  },
  {
    id: prodId3,
    type: 'blue',
    ref: `top1_i3`,
    farName: `top1`,
    sonName: `_i3`,
    son: [
      require(`../../assets/petsShopLab/ctn/4.png`)
    ]
  },
  {
    id: prodId4,
    type: 'blue',
    ref: `top1_i4`,
    farName: `top1`,
    sonName: `_i4`,
    son: [
      require(`../../assets/petsShopLab/ctn/5.png`)
    ]
  },
  {
    id: prodId5,
    type: 'blue',
    ref: `top1_i5`,
    farName: `top1`,
    sonName: `_i5`,
    son: [
      require(`../../assets/petsShopLab/ctn/6.png`)
    ]
  },
  {
    id: prodId6,
    type: 'blue',
    ref: `top2_i1`,
    farName: `top2`,
    sonName: `_i1`,
    son: [
      require(`../../assets/petsShopLab/ctn/7.png`)
    ]
  },
  {
    id: prodId6,
    type: 'blue',
    ref: `top2_i2`,
    farName: `top2`,
    sonName: `_i2`,
    son: [
      require(`../../assets/petsShopLab/ctn/8.png`)
    ]
  },
  {
    id: prodId6,
    type: 'blue',
    ref: `top2_i3`,
    farName: `top2`,
    sonName: `_i3`,
    son: [
      require(`../../assets/petsShopLab/ctn/9.jpg`)
    ]
  },
  {
    id: prodId7,
    type: 'blue',
    ref: `top3_i1`,
    farName: `top3`,
    sonName: `_i1`,
    son: [
      require(`../../assets/petsShopLab/ctn/10.png`)
    ]
  }
]

const topDiff = {
  firstSon: '_i1',
  top1_i1: 15,
  top2_i1: 3,
  top3_i1: 10
}

export default {
  title: '宠物友好店',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
